import { useSuspenseQuery } from '@tanstack/react-query'

import type { TGetPropostaRevisarResponse } from '@/features/proposta/interfaces/proposta.type'
import { GetPropostaRevisarService } from '@/features/proposta/services/get-proposta-revisar.service'
import { propostaKeys } from '@/features/proposta/utils'

export const useSuspensePropostaRevisar = (numero: number) => {
  return useSuspenseQuery<TGetPropostaRevisarResponse>({
    queryKey: propostaKeys.revisar(numero),
    queryFn: () => new GetPropostaRevisarService().execute(numero).then((response) => response.data),
  })
}
